<script>
  import { DateTime } from 'luxon'
  import { memberList$ } from '../store.js'
  import FormGateway from '../components/googleForm/FormGateway.svelte'
  import Input from '../components/googleForm/Input.svelte'
  import ButtonListInput from '../components/googleForm/ButtonListInput.svelte'
  import SwitchCheckbox from '../components/googleForm/SwitchCheckbox.svelte'

  import inspectionItemsExports from '../../../functions/generateLedgers/inspection/inspectionItems'
  const { inspectionItems } = inspectionItemsExports

  // 開発中はrequiredを無効にする
  const required = __DEV__ ? undefined : 'required'
  // const required = 'required' // 開発中にrequiredテストをしたいときはこちらを有効にする

  // 日付初期値
  let inspectionDate = DateTime.local().toFormat('yyyy-MM-dd')
</script>

<h1>日常点検基準表システム</h1>

<FormGateway
  topic="fukudakg-inspection"
  message="点検お疲れ様です。今日も1日どうぞご安全に！"
>
  <div class="box">
    <ButtonListInput
      id="carNumber"
      name="車両番号"
      label="車両番号"
      placeholder="登録番号"
      list={['姫路130い129(日野)', '姫路131き17(三菱)']}
      {required}
    />
  </div>

  <div class="box">
    <ButtonListInput
      id="member"
      name="点検者"
      label="点検者"
      placeholder="氏名"
      list={$memberList$}
      isLoading={!$memberList$}
      {required}
    />

    <Input
      type="date"
      id="inspectionDate"
      name="日付"
      label="日付"
      {required}
      bind:value={inspectionDate}
    />
  </div>

  {#each inspectionItems as category, i}
    <div class="box" data-testid={`category${i}`}>
      <h1 class="title">
        {i + 1}.{category.title}
      </h1>

      {#each category.items as item, j}
        <div
          class={item.required
            ? 'has-text-weight-bold'
            : 'has-text-weight-light'}
        >
          <!-- svelte-ignore missing-declaration -->
          <SwitchCheckbox
            id={`item${i + 1}-${j + 1}`}
            name={`${i + 1}-${j + 1}`}
            label=""
            description={item.description}
            required={required ? item.required : undefined}
          />
        </div>
      {/each}
    </div>
  {/each}
</FormGateway>
